/* tslint:disable */
/* eslint-disable */
/**
 * WeighMed Backend APIs - OpenAPI 3.0
 * You can find out more about Swagger at [https://editor.swagger.io/](https://editor.swagger.io/).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VUpdateTankRequestParams
 */
export interface VUpdateTankRequestParams {
    /**
     * Name of the tank
     * @type {string}
     * @memberof VUpdateTankRequestParams
     */
    name?: string;
    /**
     * Serial of the tank
     * @type {string}
     * @memberof VUpdateTankRequestParams
     */
    serial?: string;
    /**
     * Manufacturer of the tank
     * @type {string}
     * @memberof VUpdateTankRequestParams
     */
    manufacturer?: string;
    /**
     * Model of the tank
     * @type {string}
     * @memberof VUpdateTankRequestParams
     */
    modelType?: string;
    /**
     * Capacity (L) of the tank
     * @type {number}
     * @memberof VUpdateTankRequestParams
     */
    capacity?: number;
    /**
     * Empty weight (kg) of the tank
     * @type {number}
     * @memberof VUpdateTankRequestParams
     */
    minWeight?: number;
    /**
     * Full weight (kg) of the tank
     * @type {number}
     * @memberof VUpdateTankRequestParams
     */
    maxWeight?: number;
    /**
     * Minimum evaporation rate (kg/h) of the tank
     * @type {number}
     * @memberof VUpdateTankRequestParams
     */
    minEvaporationRate?: number;
    /**
     * Maximum evaporation rate (kg/h) of the tank
     * @type {number}
     * @memberof VUpdateTankRequestParams
     */
    maxEvaporationRate?: number;
    /**
     * Fast weight loss rate of tank for elevated alarming
     * @type {number}
     * @memberof VUpdateTankRequestParams
     */
    weightLossFastRate?: number;
    /**
     * Critical weight loss rate of tank for elevated alarming
     * @type {number}
     * @memberof VUpdateTankRequestParams
     */
    weightLossCriticalRate?: number;
    /**
     * Apex reset weight (kg) threshold
     * @type {number}
     * @memberof VUpdateTankRequestParams
     */
    apexResetWeight?: number;
    /**
     * Snooze until time for caddy battery low alarm
     * @type {string}
     * @memberof VUpdateTankRequestParams
     */
    batteryLowSnoozeUntil?: string;
    /**
     * Note for caddy battery low alarm snooze
     * @type {string}
     * @memberof VUpdateTankRequestParams
     */
    batteryLowSnoozeNote?: string;
    /**
     * Snooze until time for caddy battery critical alarm
     * @type {string}
     * @memberof VUpdateTankRequestParams
     */
    batteryCriticalSnoozeUntil?: string;
    /**
     * Note for caddy battery critical alarm snooze
     * @type {string}
     * @memberof VUpdateTankRequestParams
     */
    batteryCriticalSnoozeNote?: string;
    /**
     * Snooze until time for caddy temperature low alarm
     * @type {string}
     * @memberof VUpdateTankRequestParams
     */
    temperatureLowSnoozeUntil?: string;
    /**
     * Note for caddy temperature low alarm snooze
     * @type {string}
     * @memberof VUpdateTankRequestParams
     */
    temperatureLowSnoozeNote?: string;
    /**
     * Snooze until time for tank weight low alarm
     * @type {string}
     * @memberof VUpdateTankRequestParams
     */
    weightLowSnoozeUntil?: string;
    /**
     * Note for tank weight low alarm snooze
     * @type {string}
     * @memberof VUpdateTankRequestParams
     */
    weightLowSnoozeNote?: string;
    /**
     * Snooze until time for tank weight high alarm
     * @type {string}
     * @memberof VUpdateTankRequestParams
     */
    weightHighSnoozeUntil?: string;
    /**
     * Note for tank weight high alarm snooze
     * @type {string}
     * @memberof VUpdateTankRequestParams
     */
    weightHighSnoozeNote?: string;
    /**
     * Snooze until time for tank evaporation rate low alarm
     * @type {string}
     * @memberof VUpdateTankRequestParams
     */
    evaporationRateLowSnoozeUntil?: string;
    /**
     * Note for tank evaporation rate low alarm snooze
     * @type {string}
     * @memberof VUpdateTankRequestParams
     */
    evaporationRateLowSnoozeNote?: string;
    /**
     * Snooze until time for tank evaporation rate high alarm
     * @type {string}
     * @memberof VUpdateTankRequestParams
     */
    evaporationRateHighSnoozeUntil?: string;
    /**
     * Note for tank evaporation rate high alarm snooze
     * @type {string}
     * @memberof VUpdateTankRequestParams
     */
    evaporationRateHighSnoozeNote?: string;
    /**
     * Snooze until time for weight loss fast alarm
     * @type {string}
     * @memberof VUpdateTankRequestParams
     */
    weightLossFastSnoozeUntil?: string;
    /**
     * Note for weight loss fast alarm snooze
     * @type {string}
     * @memberof VUpdateTankRequestParams
     */
    weightLossFastSnoozeNote?: string;
    /**
     * Snooze until time for weight loss critical alarm
     * @type {string}
     * @memberof VUpdateTankRequestParams
     */
    weightLossCriticalSnoozeUntil?: string;
    /**
     * Note for weight loss critical alarm snooze
     * @type {string}
     * @memberof VUpdateTankRequestParams
     */
    weightLossCriticalSnoozeNote?: string;
    /**
     * Snooze until time for tank offline alarm
     * @type {string}
     * @memberof VUpdateTankRequestParams
     */
    offlineSnoozeUntil?: string;
    /**
     * Note for tank offline alarm snooze
     * @type {string}
     * @memberof VUpdateTankRequestParams
     */
    offlineSnoozeNote?: string;
    /**
     * If current time is less than muteUntilTime, muteCaddy will be set to true in queryConfiguration api
     * @type {string}
     * @memberof VUpdateTankRequestParams
     */
    muteUntilTime?: string;
    /**
     * Id of clinic the tank belongs to
     * @type {string}
     * @memberof VUpdateTankRequestParams
     */
    clinicId?: string;
    /**
     * Id of caddy the tank is installed
     * @type {string}
     * @memberof VUpdateTankRequestParams
     */
    caddyId?: string;
    /**
     * Ids of displays
     * @type {Array<string>}
     * @memberof VUpdateTankRequestParams
     */
    displayIds?: Array<string>;
    /**
     * The tank is active or not
     * @type {boolean}
     * @memberof VUpdateTankRequestParams
     */
    active?: boolean;
}

/**
 * Check if a given object implements the VUpdateTankRequestParams interface.
 */
export function instanceOfVUpdateTankRequestParams(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VUpdateTankRequestParamsFromJSON(json: any): VUpdateTankRequestParams {
    return VUpdateTankRequestParamsFromJSONTyped(json, false);
}

export function VUpdateTankRequestParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): VUpdateTankRequestParams {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'serial': !exists(json, 'serial') ? undefined : json['serial'],
        'manufacturer': !exists(json, 'manufacturer') ? undefined : json['manufacturer'],
        'modelType': !exists(json, 'modelType') ? undefined : json['modelType'],
        'capacity': !exists(json, 'capacity') ? undefined : json['capacity'],
        'minWeight': !exists(json, 'minWeight') ? undefined : json['minWeight'],
        'maxWeight': !exists(json, 'maxWeight') ? undefined : json['maxWeight'],
        'minEvaporationRate': !exists(json, 'minEvaporationRate') ? undefined : json['minEvaporationRate'],
        'maxEvaporationRate': !exists(json, 'maxEvaporationRate') ? undefined : json['maxEvaporationRate'],
        'weightLossFastRate': !exists(json, 'weightLossFastRate') ? undefined : json['weightLossFastRate'],
        'weightLossCriticalRate': !exists(json, 'weightLossCriticalRate') ? undefined : json['weightLossCriticalRate'],
        'apexResetWeight': !exists(json, 'apexResetWeight') ? undefined : json['apexResetWeight'],
        'batteryLowSnoozeUntil': !exists(json, 'batteryLowSnoozeUntil') ? undefined : json['batteryLowSnoozeUntil'],
        'batteryLowSnoozeNote': !exists(json, 'batteryLowSnoozeNote') ? undefined : json['batteryLowSnoozeNote'],
        'batteryCriticalSnoozeUntil': !exists(json, 'batteryCriticalSnoozeUntil') ? undefined : json['batteryCriticalSnoozeUntil'],
        'batteryCriticalSnoozeNote': !exists(json, 'batteryCriticalSnoozeNote') ? undefined : json['batteryCriticalSnoozeNote'],
        'temperatureLowSnoozeUntil': !exists(json, 'temperatureLowSnoozeUntil') ? undefined : json['temperatureLowSnoozeUntil'],
        'temperatureLowSnoozeNote': !exists(json, 'temperatureLowSnoozeNote') ? undefined : json['temperatureLowSnoozeNote'],
        'weightLowSnoozeUntil': !exists(json, 'weightLowSnoozeUntil') ? undefined : json['weightLowSnoozeUntil'],
        'weightLowSnoozeNote': !exists(json, 'weightLowSnoozeNote') ? undefined : json['weightLowSnoozeNote'],
        'weightHighSnoozeUntil': !exists(json, 'weightHighSnoozeUntil') ? undefined : json['weightHighSnoozeUntil'],
        'weightHighSnoozeNote': !exists(json, 'weightHighSnoozeNote') ? undefined : json['weightHighSnoozeNote'],
        'evaporationRateLowSnoozeUntil': !exists(json, 'evaporationRateLowSnoozeUntil') ? undefined : json['evaporationRateLowSnoozeUntil'],
        'evaporationRateLowSnoozeNote': !exists(json, 'evaporationRateLowSnoozeNote') ? undefined : json['evaporationRateLowSnoozeNote'],
        'evaporationRateHighSnoozeUntil': !exists(json, 'evaporationRateHighSnoozeUntil') ? undefined : json['evaporationRateHighSnoozeUntil'],
        'evaporationRateHighSnoozeNote': !exists(json, 'evaporationRateHighSnoozeNote') ? undefined : json['evaporationRateHighSnoozeNote'],
        'weightLossFastSnoozeUntil': !exists(json, 'weightLossFastSnoozeUntil') ? undefined : json['weightLossFastSnoozeUntil'],
        'weightLossFastSnoozeNote': !exists(json, 'weightLossFastSnoozeNote') ? undefined : json['weightLossFastSnoozeNote'],
        'weightLossCriticalSnoozeUntil': !exists(json, 'weightLossCriticalSnoozeUntil') ? undefined : json['weightLossCriticalSnoozeUntil'],
        'weightLossCriticalSnoozeNote': !exists(json, 'weightLossCriticalSnoozeNote') ? undefined : json['weightLossCriticalSnoozeNote'],
        'offlineSnoozeUntil': !exists(json, 'offlineSnoozeUntil') ? undefined : json['offlineSnoozeUntil'],
        'offlineSnoozeNote': !exists(json, 'offlineSnoozeNote') ? undefined : json['offlineSnoozeNote'],
        'muteUntilTime': !exists(json, 'muteUntilTime') ? undefined : json['muteUntilTime'],
        'clinicId': !exists(json, 'clinicId') ? undefined : json['clinicId'],
        'caddyId': !exists(json, 'caddyId') ? undefined : json['caddyId'],
        'displayIds': !exists(json, 'displayIds') ? undefined : json['displayIds'],
        'active': !exists(json, 'active') ? undefined : json['active'],
    };
}

export function VUpdateTankRequestParamsToJSON(value?: VUpdateTankRequestParams | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'serial': value.serial,
        'manufacturer': value.manufacturer,
        'modelType': value.modelType,
        'capacity': value.capacity,
        'minWeight': value.minWeight,
        'maxWeight': value.maxWeight,
        'minEvaporationRate': value.minEvaporationRate,
        'maxEvaporationRate': value.maxEvaporationRate,
        'weightLossFastRate': value.weightLossFastRate,
        'weightLossCriticalRate': value.weightLossCriticalRate,
        'apexResetWeight': value.apexResetWeight,
        'batteryLowSnoozeUntil': value.batteryLowSnoozeUntil,
        'batteryLowSnoozeNote': value.batteryLowSnoozeNote,
        'batteryCriticalSnoozeUntil': value.batteryCriticalSnoozeUntil,
        'batteryCriticalSnoozeNote': value.batteryCriticalSnoozeNote,
        'temperatureLowSnoozeUntil': value.temperatureLowSnoozeUntil,
        'temperatureLowSnoozeNote': value.temperatureLowSnoozeNote,
        'weightLowSnoozeUntil': value.weightLowSnoozeUntil,
        'weightLowSnoozeNote': value.weightLowSnoozeNote,
        'weightHighSnoozeUntil': value.weightHighSnoozeUntil,
        'weightHighSnoozeNote': value.weightHighSnoozeNote,
        'evaporationRateLowSnoozeUntil': value.evaporationRateLowSnoozeUntil,
        'evaporationRateLowSnoozeNote': value.evaporationRateLowSnoozeNote,
        'evaporationRateHighSnoozeUntil': value.evaporationRateHighSnoozeUntil,
        'evaporationRateHighSnoozeNote': value.evaporationRateHighSnoozeNote,
        'weightLossFastSnoozeUntil': value.weightLossFastSnoozeUntil,
        'weightLossFastSnoozeNote': value.weightLossFastSnoozeNote,
        'weightLossCriticalSnoozeUntil': value.weightLossCriticalSnoozeUntil,
        'weightLossCriticalSnoozeNote': value.weightLossCriticalSnoozeNote,
        'offlineSnoozeUntil': value.offlineSnoozeUntil,
        'offlineSnoozeNote': value.offlineSnoozeNote,
        'muteUntilTime': value.muteUntilTime,
        'clinicId': value.clinicId,
        'caddyId': value.caddyId,
        'displayIds': value.displayIds,
        'active': value.active,
    };
}

